<!--
 * @Author: DQL
 * @Date: 2020-04-09 17:30:45
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-01 14:30:13
 * @Description: file content
 -->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="新增"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="120px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="岗位分类代码"
              prop="roleTypeDm"
            >
              <el-input
                v-model="fd.roleTypeDm"
                class="c-form__input"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="岗位分类名称"
              prop="roleTypeName"
            >
              <el-input
                v-model="fd.roleTypeName"
                class="c-form__input"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="岗位类型"
              prop="roleType"
            >
              <el-radio-group
                v-model="fd.roleType"
                class="c-form__radio-group"
              >
                <el-radio
                  v-for="(value,key) in enums.ROLE_TYPE"
                  :key="key"
                  :label="value.id"
                >
                  {{ value.text }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { roleTypeService } from './roleType.service.js';

export default {
  name: 'AddDialog',
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载

      /* 表单参数 Start */
      fd: {
        roleTypeDm: null,
        roleTypeName: null,
        roleType: 'NORMAL'
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        roleTypeDm: [
          this.$validUtils.required('岗位分类代码'),
          this.$HMValidator.maxLength('岗位分类代码', 32)
        ],
        roleTypeName: [
          this.$validUtils.required('岗位分类名称'),
          this.$HMValidator.maxLength('岗位分类名称', 128)
        ],
        roleType: [
          this.$validUtils.required('岗位类型')
        ]
      }
      /* 表单校验规则 End */
    };
  },
  computed: {
    // 获取枚举
    enums () {
      return this.$HMStoreService.getEnums();
    }
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate(valid => {
        if (valid) {
          _this.loading = true;
          roleTypeService.save(_this.fd)
            .then(rsp => {
              _this.$alert('添加成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              _this.$emit('closeDialog', '');
              _this.$emit('callback');
            })
            .catch(err => {
              console.log('岗位分类新增错误！', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    }
  }
};
</script>
